var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accessibility-main"},[_c('button',{attrs:{"title":"Open Accessibility Settings"},on:{"click":function($event){return _vm.setActiveComponent('plugin')}}},[_c('i',{staticClass:"fas fa-universal-access"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }